export class ProductRestrictionProductCommandModel {
    public productRestrictionProductId:string;
    public restrictedProductId:string;
    public productCategoryCode:string;  
    public productGroupCode:string;        
    public productTypeCode:string;
    public excludeFlag:boolean;   
    public displaySequence:number;
}